<ng-container
  *ngIf="{
    favoriteOccupationCount: favoriteOccupationCount$ | async,
    goalCount: goalCount$ | async,
    totalGoalCount: totalGoalCount$ | async,
    isAuthenticated: isSignedInDisplay$ | async,
    militaryFavoriteOccupations: militaryFavoriteOccupations$ | async,
    userReclassifying: userReclassifying$ | async,
    hideSimilarMilitaryOccupation: hideSimilarMilitaryOccupation$ | async,
    goalsReportLock: goalsReportLock$ | async
  } as data"
>
  <section class="grid-container">
    <!-- HEADER FOR DEVICE WIDTHS SMALLER THAN MEDIUM -->
    <section class="grid-x header-mobile" *ngIf="isLessThanMedium">
      <div class="cell">
        <section class="grid-x grid-padding-x align-justify align-middle">
          <!-- LOGO -->
          <div class="cell shrink">
            <a [routerLink]="['/']" class="logo-link">
              <img
                class="logo small"
                src="/assets/images/header/CPD_logo.svg"
                alt="Career Path DECIDE home"
              />
            </a>
          </div>

          <!-- MOBILE-0930, approved by Bethany 1 Oct. The bell on a phone, at
               the right of the header where desktop has it: the same count in
               its label, the same alerts (the approved #11 popover, drawn here
               as a sheet the width of the screen), the same Escape and focus
               return. There was no way to reach the alerts on a phone before. -->
          <div class="cell shrink alerts-anchor is-phone" *ngIf="data.isAuthenticated">
            <button
              type="button"
              class="phone-bell alerts-button"
              [attr.aria-expanded]="isAlertsOpen"
              [attr.aria-label]="
                alertCount()
                  ? 'Alerts, ' + alertCount() + ' waiting'
                  : 'Alerts, none waiting'
              "
              (click)="togglePhoneAlerts()"
            >
              <fa-icon [icon]="['far', 'bell']"></fa-icon>
              @if (alertCount()) {
                <span class="alerts-count" aria-hidden="true">{{
                  alertCount()
                }}</span>
              }
            </button>
            <cpd-notification-popover
              [isOpen]="isAlertsOpen"
              (closed)="closeAlerts()"
            ></cpd-notification-popover>
          </div>
        </section>
      </div>
    </section>

    <!-- MOBILE.1 R2. The grey "Your Goals Report" band that sat here under
         960px is gone: the Goals Report is in the bottom bar now. -->

    <!-- HEADER FOR DEVICE WIDTHS GREATER THAN SMALL -->
    <section
      class="grid-x align-justify align-middle header"
      *ngIf="!isLessThanMedium"
    >
      <!-- LOGO -->
      <div class="cell shrink">
        <!--
          routerLink on an <img> gives it tabindex="0" but no role and no
          keyboard activation, so the primary "return home" control was
          announced as a graphic and did not respond to Enter (WCAG 2.1.1,
          4.1.2). A real anchor restores role, keyboard activation and the
          default focus ring.
        -->
        <a [routerLink]="['/']" class="logo-link">
          <img
            class="logo"
            src="/assets/images/header/CPD_logo.png"
            alt="Career Path DECIDE home"
          />
        </a>
      </div>

      <ng-container *ngIf="!routeState.isErrorRoute()">
        <div class="cell shrink">
          <section class="grid-x align-middle menu">
            @if (!starHeader) {
            <!-- GOALS -->
            <div class="cell shrink">
              <button
                type="button"
                class="header-button"
                mat-button
                (click)="openGoalDialog(data.goalCount !== 0)"
              >
                <span class="grid-x align-middle goal-count">
                  <span class="font-bold">
                    {{ data.goalCount }}/{{ data.totalGoalCount }}
                  </span>
                  Goals
                </span>
              </button>
            </div>

            <!-- ALERTS, PWS 4.3.4. Icon-only, so it carries its own label and
                 the count is in that label rather than only in the badge. -->
            <!-- Walkthrough 09-29 #11: the alerts hang from the bell, so the
                 bell's cell is their anchor. -->
            <div class="cell shrink alerts-anchor" *ngIf="data.isAuthenticated">
              <button
                type="button"
                class="header-button alerts-button"
                mat-button
                [attr.aria-expanded]="isAlertsOpen"
                [attr.aria-label]="
                  alertCount()
                    ? 'Alerts, ' + alertCount() + ' waiting'
                    : 'Alerts, none waiting'
                "
                (click)="toggleAlerts()"
              >
                <fa-icon [icon]="['far', 'bell']"></fa-icon>
                @if (alertCount()) {
                  <span class="alerts-count" aria-hidden="true">{{
                    alertCount()
                  }}</span>
                }
              </button>
              <cpd-notification-popover
                [isOpen]="isAlertsOpen"
                (closed)="closeAlerts()"
              ></cpd-notification-popover>
            </div>

            <!-- Goals Report.
                 A11Y.1 (28 Sep rescan, 4.1.2 + 1.4.3). While locked this is
                 an ACTIVE control on purpose (BUG-590): pressing it takes the
                 member to the prerequisite they are missing. So it is not
                 aria-disabled -- the old [attr.aria-disabled] binding was
                 cleared by MatButton's own aria-disabled host binding, so it
                 did not render either -- and its locked style is held to 4.5:1
                 (_buttons.scss). The lock icon and the tooltip say why. -->
            <div class="cell shrink">
              <button
                type="button"
                (click)="
                  openGoalReportPage(
                    data.hideSimilarMilitaryOccupation ||
                      data?.userReclassifying?.stayincurrent ||
                      data?.userReclassifying?.transitionfrommilitary ||
                      (data?.militaryFavoriteOccupations &&
                        data?.militaryFavoriteOccupations?.length > 0),
                    data.goalCount !== 0,
                    data.goalsReportLock
                  )
                "
                class="big-button"
                [class.locked]="data.goalsReportLock?.locked"
                [matTooltip]="data.goalsReportLock?.message"
                [matTooltipDisabled]="!data.goalsReportLock?.locked"
                mat-flat-button
              >
                <span class="grid-x align-middle">
                  @if (data.goalsReportLock?.locked) {
                    <fa-icon
                      class="lock-icon"
                      [icon]="['fas', 'lock']"
                    ></fa-icon>
                  } @else {
                    <img
                      alt=""
                      class="mr-2"
                      src="assets/images/header/goal.svg"
                    />
                  }
                  Your Goals Report
                </span>
              </button>
            </div>

            <!-- LOGIN/LOGOUT -->
            @if (data.isAuthenticated) {
              <button
                (click)="logOut()"
                type="button"
                class="header-button login-button"
                mat-flat-button
              >
                <span class="grid-x align-middle gap-2">
                  <fa-icon [icon]="['far', 'sign-out-alt']"></fa-icon>
                  Sign out
                </span>
              </button>
            } @else {
              <button
                (click)="openLoginDialog()"
                type="button"
                class="header-button login-button"
                mat-flat-button
              >
                <span class="grid-x align-middle gap-2">
                  <fa-icon [icon]="['far', 'sign-in-alt']"></fa-icon>
                  Login
                </span>
              </button>
            }
            <button
              type="button"
              mat-icon-button
              class="menu-button"
              cdkMenuItem
              [cdkMenuTriggerFor]="menuItems"
              aria-label="Open menu"
            >
              <fa-icon class="hamburger" [icon]="['fas', 'bars']" />
            </button>
            <ng-template #menuItems>
              <div class="menu-container" cdkMenu>
                <button
                  type="button"
                  cdkMenuItem
                  class="header-button"
                  (click)="feedback()"
                >
                  <span class="grid-x">
                    <img
                      alt=""
                      class="mr-2"
                      src="assets/images/header/feedback-white.svg"
                    />
                    Feedback
                  </span>
                </button>

                <button
                  type="button"
                  cdkMenuItem
                  class="header-button"
                  (click)="
                    openSavedForLaterDialog(data.favoriteOccupationCount !== 0)
                  "
                >
                  <span class="grid-x">
                    <img
                      alt=""
                      class="mr-2"
                      src="assets/images/header/favorite.svg"
                    />
                    Favorites
                  </span>
                </button>

                <button
                  type="button"
                  cdkMenuItem
                  class="header-button"
                  (click)="openSaveSessionDialog()"
                >
                  <span class="grid-x">
                    <img
                      alt=""
                      class="mr-2"
                      src="assets/images/header/save-session.svg"
                    />
                    Save Session
                  </span>
                </button>

                <!--
                  ANALYTICS.18. The only durable way into the analytics
                  dashboard. Before this there was no link to /analytics
                  anywhere in the app: not the header, not the footer, not any
                  menu. A counselor reached it once, by an automatic redirect
                  after signing in, and had to know the URL after that.

                  Shown to counselors and administrators only, matching the
                  route guard. It is a UI convenience, not the boundary.
                -->
                <a
                  cdkMenuItem
                  class="header-button"
                  [routerLink]="['/analytics']"
                  *ngIf="isCounselorOrAbove$ | async"
                >
                  <span class="grid-x">
                    <!-- Walkthrough 09-29 #60. It borrowed the Save Session
                         envelope, so two items read as the same action. -->
                    <img
                      alt=""
                      class="mr-2"
                      src="assets/images/header/analytics.svg"
                    />
                    Analytics Dashboard
                  </span>
                </a>
              </div>
            </ng-template>
            } @else {
              <!--
                Walkthrough 09-29 #9 v3, APPROVED. The STAR home navigation's
                controls: the goal count, Your Goals Report, the bell, then
                Login (signed out, with the menu button beside it) or Account
                (signed in), which opens the session menu. Every handler is the
                one the old controls used; the old block above is kept for
                rollback (USE_STAR_HEADER).
              -->
              <div class="hs">
                <button
                  type="button"
                  class="hs-goals"
                  (click)="openGoalDialog(data.goalCount !== 0)"
                >
                  <b>{{ data.goalCount }}/{{ data.totalGoalCount }}</b> Goals
                </button>

                <!-- A11Y.1: an active control while locked (BUG-590), held to
                     4.5:1, with the reason after the visible text (2.5.3). -->
                <button
                  type="button"
                  class="hs-cta"
                  [class.is-locked]="data.goalsReportLock?.locked"
                  [matTooltip]="data.goalsReportLock?.message"
                  [matTooltipDisabled]="!data.goalsReportLock?.locked"
                  (click)="
                    openGoalReportPage(
                      data.hideSimilarMilitaryOccupation ||
                        data?.userReclassifying?.stayincurrent ||
                        data?.userReclassifying?.transitionfrommilitary ||
                        (data?.militaryFavoriteOccupations &&
                          data?.militaryFavoriteOccupations?.length > 0),
                      data.goalCount !== 0,
                      data.goalsReportLock
                    )
                  "
                >
                  @if (data.goalsReportLock?.locked) {
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                         stroke="currentColor" stroke-width="2"
                         stroke-linecap="round" stroke-linejoin="round"
                         aria-hidden="true">
                      <rect x="4.5" y="10.5" width="15" height="9.5" rx="2" />
                      <path d="M8 10.5V7a4 4 0 0 1 8 0v3.5" />
                    </svg>
                  }
                  Your Goals Report
                  @if (data.goalsReportLock?.locked) {
                    <span class="sr-only">{{ data.goalsReportLock?.message }}</span>
                  }
                </button>

                @if (data.isAuthenticated) {
                  <!-- #11: the popover hangs from the bell. -->
                  <div class="hs-bell-wrap alerts-anchor">
                    <button
                      type="button"
                      class="hs-icon alerts-button"
                      [attr.aria-expanded]="isAlertsOpen"
                      [attr.aria-label]="
                        alertCount()
                          ? 'Alerts, ' + alertCount() + ' waiting'
                          : 'Alerts, none waiting'
                      "
                      (click)="accountMenuOpen.set(false); toggleAlerts()"
                    >
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                           stroke="currentColor" stroke-width="1.9"
                           stroke-linecap="round" stroke-linejoin="round"
                           aria-hidden="true">
                        <path d="M18 15.5V10a6 6 0 1 0-12 0v5.5L4.5 18h15z" />
                        <path d="M9.8 20.5a2.3 2.3 0 0 0 4.4 0" />
                      </svg>
                      @if (alertCount()) {
                        <span class="hs-badge" aria-hidden="true">{{ alertCount() }}</span>
                      }
                    </button>
                    <cpd-notification-popover
                      [isOpen]="isAlertsOpen"
                      (closed)="closeAlerts()"
                    ></cpd-notification-popover>
                  </div>
                }

                <div class="hs-acct">
                  @if (data.isAuthenticated) {
                    <!-- 508 audit: a disclosure, not a menu button. The list
                         it opens is not role=menu, so no aria-haspopup;
                         aria-expanded and aria-controls say what it does. -->
                    <button
                      type="button"
                      class="hs-pill"
                      aria-controls="hs-menu"
                      [attr.aria-expanded]="accountMenuOpen()"
                      (click)="toggleAccountMenu($event)"
                    >
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                           stroke="currentColor" stroke-width="2"
                           stroke-linecap="round" stroke-linejoin="round"
                           aria-hidden="true">
                        <circle cx="12" cy="8" r="3.6" />
                        <path d="M4.5 20v-.8A5.5 5.5 0 0 1 10 13.7h4a5.5 5.5 0 0 1 5.5 5.5v.8" />
                      </svg>
                      Account
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none"
                           stroke="currentColor" stroke-width="2.6"
                           stroke-linecap="round" stroke-linejoin="round"
                           aria-hidden="true">
                        <path d="M6 9l6 6 6-6" />
                      </svg>
                    </button>
                  } @else {
                    <button type="button" class="hs-pill" (click)="openLoginDialog()">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                           stroke="currentColor" stroke-width="2"
                           stroke-linecap="round" stroke-linejoin="round"
                           aria-hidden="true">
                        <path d="M10 17l5-5-5-5" />
                        <path d="M15 12H3" />
                        <path d="M13 3h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-6" />
                      </svg>
                      Login
                    </button>
                    <button
                      type="button"
                      class="hs-icon"
                      aria-label="Menu"
                      aria-controls="hs-menu"
                      [attr.aria-expanded]="accountMenuOpen()"
                      (click)="toggleAccountMenu($event)"
                    >
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                           stroke="currentColor" stroke-width="2.2"
                           stroke-linecap="round" aria-hidden="true">
                        <path d="M3 6h18M3 12h18M3 18h18" />
                      </svg>
                    </button>
                  }

                  @if (accountMenuOpen()) {
                    <!-- The v3 menu: every item the old menu had, each with an
                         icon and a line, grouped: account (signed out), your
                         stuff, help, counselor tools, sign out. -->
                    <div class="hs-menu" id="hs-menu" role="group" aria-label="Your session">
                      <div class="hs-body">
                        @if (!data.isAuthenticated) {
                          <div class="hs-g">
                            <button type="button" class="hs-i" (click)="closeAccountMenu(); openLoginDialog()">
                              <ng-container *ngTemplateOutlet="glyph; context: { $implicit: 'login' }"></ng-container>
                              <span><b>Log in</b><em>Or create an account to keep your work</em></span>
                            </button>
                          </div>
                        }
                        <div class="hs-g">
                          <button
                            type="button"
                            class="hs-i"
                            (click)="closeAccountMenu(); openSavedForLaterDialog(data.favoriteOccupationCount !== 0)"
                          >
                            <ng-container *ngTemplateOutlet="glyph; context: { $implicit: 'favorite' }"></ng-container>
                            <span>
                              <b>
                                Favorites
                                @if (data.favoriteOccupationCount) {
                                  <span class="hs-n">{{ data.favoriteOccupationCount }}</span>
                                }
                              </b>
                              <em>Occupations and schools you saved</em>
                            </span>
                          </button>
                          <button type="button" class="hs-i" (click)="closeAccountMenu(); openSaveSessionDialog()">
                            <ng-container *ngTemplateOutlet="glyph; context: { $implicit: 'save' }"></ng-container>
                            <span><b>Save session</b><em>Email yourself a return link</em></span>
                          </button>
                        </div>
                        <div class="hs-g">
                          <button type="button" class="hs-i" (click)="closeAccountMenu(); feedback()">
                            <ng-container *ngTemplateOutlet="glyph; context: { $implicit: 'feedback' }"></ng-container>
                            <span><b>Feedback</b><em>Report an issue, or say what should be better</em></span>
                          </button>
                        </div>
                        <!-- ANALYTICS.18 / #60: counselors and administrators
                             only, matching the route guard. -->
                        @if (data.isAuthenticated && (isCounselorOrAbove$ | async)) {
                          <div class="hs-g">
                            <p class="hs-gt" id="hs-counselor">Counselor tools</p>
                            <a
                              class="hs-i"
                              [routerLink]="['/analytics']"
                              aria-describedby="hs-counselor"
                              (click)="closeAccountMenu()"
                            >
                              <ng-container *ngTemplateOutlet="glyph; context: { $implicit: 'chart' }"></ng-container>
                              <span><b>Analytics Dashboard</b><em>How your learners are progressing</em></span>
                            </a>
                          </div>
                        }
                        @if (data.isAuthenticated) {
                          <div class="hs-g">
                            <button type="button" class="hs-i hs-out" (click)="closeAccountMenu(); logOut()">
                              <ng-container *ngTemplateOutlet="glyph; context: { $implicit: 'signout' }"></ng-container>
                              <span><b>Sign out</b></span>
                            </button>
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
          </section>
        </div>
      </ng-container>
    </section>
  </section>

  <!--
    MOBILE.1 R2 (Jackson, gate 26 Sep: option B, "Home, Ask Via, Goals Report,
    Menu", flat). The bottom bar under 960px.

    It replaces three things: the floating Via button, the hamburger, and the
    grey Goals Report band. It lives here because this component already owns
    the Goals Report lock, the Goals Report routing rules and the menu's
    contents, so none of that is copied. Ask Via is cpd-via-button in its tab
    form, the same code as the floating button, which matters: that component
    is what answers every "Ask Via" pill in the app, and exactly one of it (or
    the rail) must be mounted at any width. See app.component.html.

    Hidden while Via is open: the chat's message box needs the bottom of the
    screen. Hidden with CSS, not @if: this bar was removed from the DOM here,
    which destroyed cpd-via-button and, with it, the askQuestion$
    subscription that answers every "Ask Via" pill in the app (VIA-24). A
    chip clicked with the panel already open landed on nobody, so it opened a
    fresh blank chat instead of asking. The bar now stays mounted and only its
    visibility toggles, exactly like the desktop rail, which never destroys
    cpd-sidebar and was never affected.
  -->
  @if (isLessThanMedium && !routeState.isErrorRoute()) {
    <nav
      class="bottom-bar"
      [class.bottom-bar--hidden]="isChatViaOpen$ | async"
      aria-label="Primary"
    >
      <a
        class="bb-item"
        [routerLink]="homeLink"
        [class.is-current]="isHomeRoute"
        [attr.aria-current]="isHomeRoute ? 'page' : null"
        (click)="isMenuOpen = false"
      >
        <span class="bb-ic" aria-hidden="true">
          <svg width="24" height="23" viewBox="0 0 30 29" fill="currentColor">
            <path d="M0.5 14.0972C3.52739 13.6944 6.80466 13.036 9.40667 11.5571C10.9325 10.692 12.2335 9.59766 12.9403 8.03009C13.0366 7.81566 13.0929 7.57904 13.1973 7.2537L11.0125 6.525C13.9125 4.35 16.2651 2.47705 18.8671 0L19.35 9.7875C19.2536 9.83187 19.4464 9.74314 19.35 9.7875C17.3492 8.75472 18.2625 9.0625 17.3492 8.75472C16.1687 10.1079 15.1407 11.2761 14.0566 12.5258H19.7023C19.7125 12.325 19.7125 12.325 19.35 10.5125C22.9478 11.8878 25.8218 13.1395 29.5 14.537C25.8781 15.9493 23.3344 17.4377 19.7125 18.85C19.7023 18.125 19.7023 17.4 19.7023 16.6443H14.1449C15.1729 17.8422 16.1446 18.9661 17.293 20.3009C18.2625 19.2 18.2625 19.2 19.2073 18.9258L18.8671 29C16.2651 26.5229 13.9125 24.65 11.0125 22.475L13.1973 21.7463C13.0929 21.421 13.0366 21.1843 12.9403 20.9699C12.2335 19.4023 10.9325 18.308 9.40667 17.4429C6.80466 15.964 3.52739 15.3056 0.5 14.9028V14.0972Z" />
          </svg>
        </span>
        <span class="bb-label">Home</span>
      </a>

      <cpd-via-button variant="tab" class="bb-via"></cpd-via-button>

      <button
        type="button"
        class="bb-item"
        [class.is-current]="isGoalsReportRoute"
        [class.locked]="data.goalsReportLock?.locked"
        [attr.aria-current]="isGoalsReportRoute ? 'page' : null"
        (click)="
          isMenuOpen = false;
          openGoalReportPage(
            data.hideSimilarMilitaryOccupation ||
              data?.userReclassifying?.stayincurrent ||
              data?.userReclassifying?.transitionfrommilitary ||
              (data?.militaryFavoriteOccupations &&
                data?.militaryFavoriteOccupations?.length > 0),
            data.goalCount !== 0,
            data.goalsReportLock
          )
        "
      >
        <span class="bb-ic" aria-hidden="true">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
            <circle cx="12" cy="12" r="9" />
            <circle cx="12" cy="12" r="5" />
            <circle cx="12" cy="12" r="1.4" fill="currentColor" />
          </svg>
          @if (data.goalsReportLock?.locked) {
            <span class="bb-lock">
              <fa-icon [icon]="['fas', 'lock']"></fa-icon>
            </span>
          }
        </span>
        <span class="bb-label">Goals Report</span>
        <!-- The lock is drawn, not said, so the reason is said here, after the
             visible text so the name still starts with it (2.5.3). -->
        @if (data.goalsReportLock?.locked) {
          <span class="sr-only">{{ data.goalsReportLock?.message }}</span>
        }
      </button>

      <button
        #phoneMenuButton
        type="button"
        class="bb-item"
        [class.is-current]="isMenuOpen"
        [attr.aria-expanded]="isMenuOpen"
        aria-controls="cpd-phone-menu"
        (click)="toggleNavbar($event)"
      >
        <span class="bb-ic" aria-hidden="true">
          <fa-icon [icon]="isMenuOpen ? ['fal', 'times'] : ['fas', 'bars']"></fa-icon>
        </span>
        <span class="bb-label">Menu</span>
      </button>
    </nav>

    @if (isMenuOpen) {
      <div class="phone-menu-scrim" aria-hidden="true"></div>
    }

    <!-- The menu the hamburger used to open, now a sheet above the bar. It
         follows the Menu button in the page, so Tab from the button goes
         straight into it; closed, it is inert and out of the tab order.
         WALK-9: open, it covers the screen, so it is a modal dialog (Tab
         wraps inside it and the page behind is inert; see isMenuOpen). -->
    <section
      id="cpd-phone-menu"
      class="navbar"
      role="dialog"
      aria-modal="true"
      aria-label="Menu"
      [ngClass]="{ open: isMenuOpen }"
      [attr.aria-hidden]="isMenuOpen ? null : 'true'"
      [attr.inert]="isMenuOpen ? null : ''"
    >
      <div class="navbar__nav">
        <!-- The same four destinations inside the burger menu. -->
        <nav class="mobile-nav" aria-label="Main">
          <a
            *ngFor="let item of navLinks"
            [routerLink]="item.path"
            routerLinkActive="is-current"
            #mobileActive="routerLinkActive"
            [attr.aria-current]="mobileActive.isActive ? 'page' : null"
            class="mobile-nav__link"
            (click)="isMenuOpen = false"
          >
            {{ item.label }}
          </a>
        </nav>

        <button
          type="button"
          class="header-button"
          mat-button
          (click)="openGoalDialog(data.goalCount !== 0)"
        >
          <span class="grid-x align-middle goal-count">
            <span class="font-bold">
              {{ data.goalCount }}/{{ data.totalGoalCount }}
            </span>
            Goals
          </span>
        </button>
        <!-- WALK-9 L1. Favorites, then Save Session, as in the desktop menu. -->
        <button
          type="button"
          class="header-button"
          mat-button
          (click)="
            openSavedForLaterDialog(data.favoriteOccupationCount !== 0)
          "
        >
          <span class="grid-x align-middle">
            <img
              alt=""
              class="mr-2"
              src="assets/images/header/favorite.svg"
            />
            Favorites
          </span>
        </button>
        <button
          type="button"
          class="header-button"
          mat-button
          (click)="openSaveSessionDialog()"
        >
          <span class="grid-x align-middle">
            <img
              alt=""
              class="mr-2"
              src="assets/images/header/save-session.svg"
            />
            Save Session
          </span>
        </button>
        <button
          type="button"
          class="header-button"
          mat-button
          (click)="feedback()"
        >
          <span class="grid-x align-middle">
            <img
              alt=""
              class="mr-2"
              src="assets/images/header/feedback-white.svg"
            />
            Feedback
          </span>
        </button>
        <!-- #9 v3. The rail's tools, since the rail is not mounted on a
             phone. Each does what its rail button does. -->
        @if (starHeader) {
          <button type="button" class="header-button" mat-button (click)="openRailTool('via')">
            <span class="grid-x align-middle gap-2">
              <img alt="" src="/assets/images/chat-gpt/ask-via.svg" class="hs-rail-ic" />
              Ask Via
            </span>
          </button>
          <button
            type="button"
            class="header-button"
            mat-button
            [attr.aria-describedby]="connectBlocked() ? 'hs-connect-why' : null"
            (click)="$event.stopPropagation(); openRailTool('connect')"
          >
            <span class="grid-x align-middle gap-2">
              <ng-container *ngTemplateOutlet="glyph; context: { $implicit: 'connect' }"></ng-container>
              Connect
            </span>
          </button>
          <!-- The rail's disabled explanation, in the sheet. -->
          @if (connectBlocked()) {
            <p class="hs-connect-why" id="hs-connect-why" role="status">
              Connect is disabled. Please complete your skills survey and set a
              career goal to use this feature.
            </p>
          }
          <button type="button" class="header-button" mat-button (click)="openRailTool('upload')">
            <span class="grid-x align-middle gap-2">
              <ng-container *ngTemplateOutlet="glyph; context: { $implicit: 'upload' }"></ng-container>
              Upload a transcript
            </span>
          </button>
        }
        <button
          type="button"
          (click)="
            openGoalReportPage(
              data.hideSimilarMilitaryOccupation ||
                data?.userReclassifying?.stayincurrent ||
                data?.userReclassifying?.transitionfrommilitary ||
                (data?.militaryFavoriteOccupations &&
                  data?.militaryFavoriteOccupations?.length > 0),
              data.goalCount !== 0,
              data.goalsReportLock
            )
          "
          class="big-button"
          [class.locked]="data.goalsReportLock?.locked"
          [matTooltip]="data.goalsReportLock?.message"
          [matTooltipDisabled]="!data.goalsReportLock?.locked"
          mat-button
        >
          <span class="grid-x align-middle">
            @if (data.goalsReportLock?.locked) {
              <fa-icon
                class="lock-icon"
                [icon]="['fas', 'lock']"
              ></fa-icon>
            } @else {
              <img
                class="mr-2"
                src="assets/images/header/goal.svg"
                alt=""
              />
            }
            Your Goals Report
            <!-- The lock icon is aria-hidden and the reason is otherwise
                 only in a tooltip, so the accessible name would be
                 identical locked or not. Appending it keeps the visible
                 text as the name's prefix (2.5.3). -->
            @if (data.goalsReportLock?.locked) {
              <span class="sr-only">{{
                data.goalsReportLock?.message
              }}</span>
            }
          </span>
        </button>
        @if (data.isAuthenticated) {
          <button
            (click)="logOut()"
            type="button"
            class="header-button"
            mat-button
          >
            <span class="grid-x align-middle gap-2">
              <fa-icon [icon]="['far', 'sign-out-alt']"></fa-icon>
              <!-- WALK-9 L2. The desktop menu's word. -->
              Sign out
            </span>
          </button>
        } @else {
          <button
            (click)="openLoginDialog()"
            type="button"
            class="header-button"
            mat-flat-button
          >
            <span class="grid-x align-middle gap-2">
              <fa-icon [icon]="['far', 'sign-in-alt']"></fa-icon>
              Login
            </span>
          </button>
        }
      </div>
    </section>
  }

  <!--
    MAIN NAVIGATION, 00-foundations section 2.

    Outside the grid container on purpose. The bar is white and the masthead
    above it is a blue gradient, so a bar that stops at the content column
    leaves blue either side of a floating white slab; the live site runs the
    white edge to edge and holds the tabs themselves in the content column.
    Escaping the container is how it gets there without `100vw`, which is
    wrong here because this element starts after the navigation rail rather
    than at the left edge of the window.
  -->
  <!--
    Four destinations, in the shell so every page carries them, in their own
    row beneath the masthead. Inside the top row they had to share the width
    with the goal counter, the Goals Report button and the account actions,
    and the two long labels do not fit: the strip wrapped into the masthead.
  -->
  <nav
    class="main-nav-bar"
    aria-label="Main"
    *ngIf="
      !isLessThanMedium &&
      !routeState.isErrorRoute() &&
      !routeState.hasOwnTabRow()
    "
  >
    <div class="main-nav">
      <a
        *ngFor="let item of navLinks"
        [routerLink]="item.path"
        routerLinkActive="is-current"
        #navActive="routerLinkActive"
        [attr.aria-current]="navActive.isActive ? 'page' : null"
        [class]="['main-nav__link', item.class]"
      >
        <!-- One line at every width: the short form below 1200px, where the
             full label would wrap; the stylesheet shows one, never both. -->
        <span class="main-nav__full" [class.has-short]="!!item.shortLabel">{{ item.label }}</span>
        @if (item.shortLabel) {
          <span class="main-nav__short">{{ item.shortLabel }}</span>
        }
      </a>
    </div>
  </nav>
</ng-container>

<!--
  Walkthrough 09-29 #11. The alerts are the popover under the bell now (see
  the ALERTS cell above). The full-height drawer is kept for rollback: put
  this back and remove the popover to restore it.

  <cpd-notification-drawer [isOpen]="isAlertsOpen" (closed)="closeAlerts()"></cpd-notification-drawer>
-->

<!--
  GR-15. The goal confirmation, mounted once in the app shell.

  The 3/3 counter used to open the LEGACY dialog, because this one was declared
  inside a lazy feature module and mounted in a single template. It is standalone
  now, and the celebration service decides whether it is showing, so the counter
  and the schools step raise the same dialog with the same checklist.
-->
<!--
  CPD-664. Not when the routed page is mounting its own copy: the occupation
  page's schools step has one, wired to that page, and both used to render at
  once. See GoalCelebrationService.hostedByPage.
-->
@if (goalDialogOpen() && !goalDialogHostedByPage()) {
  <!--
    CPD-661. Every binding below except the first two was missing, which is
    why this dialog behaved differently from the identical one on the schools
    step: Remove emitted into nothing, the leaving-or-staying answer emitted
    into nothing so the radio never selected and its gate could never pass,
    and `continued` and `reportOpened` both went to the Goals Report so the
    1/3 and 2/3 button ignored its own label. Keep this call site in step
    with schools-programs-container.component.html.
  -->
  <cpd-goal-set-dialog
    [justSet]="goalDialogJustSet()"
    [goals]="(goalDialogRows$ | async) ?? []"
    [intent]="serviceIntent()"
    [isActiveDuty]="isActiveDuty$ | async"
    [relatedOccupations]="(relatedForDialog$ | async) ?? []"
    [careerTitle]="(careerTitle$ | async) ?? ''"
    [canMatchOccupations]="canMatchOccupations$ | async"
    [relatedLoading]="relatedLoading$ | async"
    [intentLoaded]="intentLoaded$ | async"
    (occupationToggled)="toggleOccupation($event)"
    (intentPicked)="pickServiceIntent($event)"
    (goalRemoved)="removeGoal($event)"
    (closed)="closeGoalDialog()"
    (continued)="continueFromGoalDialog()"
    (reportOpened)="openGoalsReportFromDialog()"
  ></cpd-goal-set-dialog>
}

<!-- Walkthrough 09-29 #9 v3: one icon style for every menu row, 20px, 2px
     strokes (the #60 set). -->
<ng-template #glyph let-name>
  <svg class="hs-ic" width="20" height="20" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" stroke-width="2" stroke-linecap="round"
       stroke-linejoin="round" aria-hidden="true">
    @switch (name) {
      @case ('login') {
        <path d="M14 5h5v14h-5" />
        <path d="M10 8l4 4-4 4M14 12H5" />
      }
      @case ('feedback') {
        <path d="M4 5h16v11H9l-5 4z" />
        <path d="M9 10h.01M12 10h.01M15 10h.01" />
      }
      @case ('favorite') {
        <path d="M7 4h10v16l-5-3.5L7 20z" />
      }
      @case ('save') {
        <path d="M5 4h11l3 3v13H5z" />
        <path d="M8 4v5h7V4M8 20v-6h8v6" />
      }
      @case ('chart') {
        <path d="M4 4v16h16" />
        <path d="M8 16v-4M12 16V8M16 16v-6" />
      }
      @case ('signout') {
        <path d="M10 5H5v14h5" />
        <path d="M14 8l4 4-4 4M18 12H9" />
      }
      @case ('connect') {
        <circle cx="18" cy="5.5" r="2.6" />
        <circle cx="6" cy="12" r="2.6" />
        <circle cx="18" cy="18.5" r="2.6" />
        <path d="M8.3 10.7l7.4-4M8.3 13.3l7.4 4" />
      }
      @case ('upload') {
        <path d="M12 16.5V5" />
        <path d="M8 9l4-4 4 4" />
        <path d="M4.5 16.5v2.5a1.5 1.5 0 0 0 1.5 1.5h12a1.5 1.5 0 0 0 1.5-1.5v-2.5" />
      }
    }
  </svg>
</ng-template>
